import styled from 'styled-components';
import 'react-datepicker/dist/react-datepicker.css';
import { CenterRowDiv, RowDiv, theme } from 'styles';

export const DateDiv = styled(CenterRowDiv)`
  border-radius: 8px;
  width: 180px;
  height: 40px;
  padding: ${({ $desc }) => ($desc && `0 12px`) || '8px 12px'};
  background-color: ${theme.colors.gray50};
  gap: 16px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: 150ms ease;

  &:hover {
    background-color: ${theme.colors.gray100};
  }

  &:focus,
  &:active {
    background-color: ${theme.colors.gray50};
    border-color: ${theme.colors.gray300};
  }
`;

export const YearDiv = styled(RowDiv)`
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  transition: 150ms ease;

  &:hover {
    background-color: ${theme.colors.fill05};
  }
  &:active {
    background-color: ${theme.colors.fill12};
  }
`;

export const CustomDiv = styled.div`
  position: absolute;
  top: 72px;

  .react-datepicker {
    height: auto;
    width: 254px;
    box-shadow: ${theme.shadows.elevation04};
    font-family: 'Pretendard';
    padding: 24px;
    border: 0;
    border-radius: 8px;
    color: ${theme.colors.assistive};
  }

  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    width: 24px;
    height: 24px;
    cursor: pointer;
    padding: 4px;
    border-radius: 12px;
    border: 1px solid transparent;

    &:not(.year):hover {
      background-color: ${theme.colors.fill05};
    }

    &:not(.year):active {
      background-color: ${theme.colors.fill12};
    }

    &:not(.year):focus-visible:not(:disabled) {
      border-color: ${theme.colors.fill05};
    }
  }

  .react-datepicker__day--outside-month {
    color: ${theme.colors.disabled} !important;
  }
  .next > span {
    transform: rotate(-180deg);
  }

  .year {
    background-color: transparent;
  }

  .year > span {
    transform: rotate(-90deg);
  }

  .react-datepicker__header {
    background-color: white;
    border: none;
    padding: 0;
    border-top-left-radius: 0;
  }

  .react-datepicker__day-name {
    font-size: 14px;
    line-height: 1;
    width: 22px;
    height: 20px;
    margin: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${theme.colors.supportive};
    font-size: 12px;
    font-weight: 500;
  }

  .react-datepicker__day-names {
    margin-bottom: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }

  .react-datepicker__day {
    border-radius: 50%;
    height: 22px;
    width: 22px;
    font-size: 14px;
    line-height: 1;
    margin: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: white;
    color: ${theme.colors.assistive};
  }

  .react-datepicker__month {
    margin: 0;
  }

  .react-datepicker__month,
  .react-datepicker__week {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .react-datepicker__day--today {
    font-weight: 400;
    color: ${theme.colors.normal};
    border: 1px solid ${theme.colors.primary100};
  }

  .react-datepicker__day--selected {
    background-color: ${theme.colors.primary};
    color: #ffffff;
  }

  .react-datepicker__day:hover {
    background-color: ${theme.colors.primary50};
  }

  .react-datepicker__day:focus {
    border: 1px solid ${theme.colors.fill05};
  }

  .react-datepicker__day:active {
    background-color: ${theme.colors.primary100};
  }

  .react-datepicker__day--selected:hover {
    background-color: ${theme.colors.primary400};
  }

  .react-datepicker__year {
    margin: 0;
  }

  .react-datepicker__year-wrapper {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
  }

  .react-datepicker__year .react-datepicker__year-text {
    width: 45px;
    height: 22px;
    margin: 0;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid transparent;
    border-radius: 100px;
  }

  .react-datepicker__year .react-datepicker__year-text:hover {
    background-color: ${theme.colors.primary50};
  }

  .react-datepicker__year-text--selected {
    color: #ffffff;
    background-color: ${theme.colors.primary};
    font-weight: 400;
  }

  .react-datepicker__year-text--selected:hover {
    background-color: ${theme.colors.primary400};
  }

  .react-datepicker__year-text--today {
    border-color: ${theme.colors.primary100} !important;
    font-weight: 400;
  }
`;
